
import { defineComponent, reactive, toRefs } from "vue";

export default defineComponent({
  setup() {
    const state = reactive({
      codeList: [
        {
          id: "1",
          code: 1,
          description: "请求成功",
        },
        {
          id: "2",
          code: -1,
          description: "请求失败，请重试",
        },
        {
          id: "3",
          code: 1001,
          description: "参数缺失或为空",
        },
        {
          id: "4",
          code: 1002,
          description: "参数错误或无效",
        },
        {
          id: "5",
          code: 2001,
          description: "请求不合法",
        },
        {
          id: "6",
          code: 2002,
          description: "请求已过期",
        },
        {
          id: "7",
          code: 2003,
          description: "请求的接口不存在",
        },
        {
          id: "8",
          code: 4001,
          description: "相关资源无权限",
        },
        {
          id: "9",
          code: 4004,
          description: "相关资源不存在",
        },
        {
          id: "10",
          code: 5001,
          description: "服务器内部错误",
        },
        {
          id: "11",
          code: 5002,
          description: "服务器繁忙，请重试",
        },
      ],
    });

    return {
      ...toRefs(state),
    };
  },
});
